module.exports = __webpack_public_path__ + "img/slide2.9986976e.png";